module.exports = __webpack_public_path__ + "static/media/logo_rantai.57e3913a.png";